import { render, staticRenderFns } from "./inquiry_list.vue?vue&type=template&id=67f9a587&scoped=true"
import script from "./inquiry_list.vue?vue&type=script&lang=js"
export * from "./inquiry_list.vue?vue&type=script&lang=js"
import style0 from "./inquiry_list.vue?vue&type=style&index=0&id=67f9a587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f9a587",
  null
  
)

export default component.exports